import React from 'react';
import { useInView } from 'react-intersection-observer';

const LazyImage = ({ src, alt, className, style }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  return (
    <img
      alt={alt || "image"}
      src={inView ? src : ''}
      className={className}
      loading={inView ? 'auto' : 'lazy'}
      ref={ref}
      style={style}
    />
  );
};

export default LazyImage;